import script from "./ServicesSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ServicesSection.vue?vue&type=script&setup=true&lang=js"

import "./ServicesSection.vue?vue&type=style&index=0&id=7f701d8e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f701d8e"]])

export default __exports__